import React from 'react';
import { useTranslation } from 'react-i18next';

import { Design } from '../../../../../viewer/elements/design';
import { Dxf } from '../../../../../viewer/elements/dxf';
import { Geometry } from '../../../../../viewer/elements/geometry';
import { Glb } from '../../../../../viewer/elements/glb';
import { TerrainModel } from '../../../../../viewer/elements/terrain-model';
import { useNonce } from '../../../../hooks/use-nonce';
import { LabelledContainer } from '../../../labelled-container/labelled-container';
import { Slider } from '../../../slider/slider';

type Props = {
  asset: Geometry | Dxf | Glb | Design | TerrainModel;
};

const OpacitySection = (props: Props) => {
  const { t } = useTranslation();
  const [_, refresh] = useNonce();

  return (
    <LabelledContainer
      text={t('opacity.sectionName', {
        ns: 'skyviewAssetMenu',
        value: props.asset.opacity,
      })}
    >
      <Slider
        disabled={!props.asset.visible || props.asset.loadingStatus === 'loading'}
        max={1}
        min={0}
        step={0.01}
        value={props.asset.opacity}
        onChange={(value: number) => {
          props.asset.opacity = value;
          refresh();
        }}
      />
    </LabelledContainer>
  );
};

export { OpacitySection, Props as OpacitySectionProps };
